import ViewConstructor from './../components/ViewConstructor';

import {
  flattenMultiArray,
  generateUID,
  getUrlParameter,
} from './../../_util.js';

/** Class representing the GallerySidebar */
class GallerySidebar extends ViewConstructor {
  /**
  componentDidMount - override method of ViewConstructor
  */
  componentDidMount() {
    const that = this;
    
    this.getSidebarData();

    $(window).bind('update-filters', function() {
      if (that.state.gallery) {
        that.renderFilters(that.state.gallery.state.cases.filters);
      }
    });
  }

  /**
  getSidebarData
  - Using the api object that is passed in this method will reach out to the API and get all procedure categories. Once the data is received it will update the galleries state (which saves the categories and is referenced elsewhere). 
  - This also triggers the enterScreen method then fires the gallery addLinkEventListeners method applying event listers to all new links added here. 

  refactor oportunity: Use some sort of shared state in the browsers local storage.
  */
  getSidebarData() {
    const that = this;

    this.state.api.getCategories(function (categoriesRes){
      that.renderProcedures(categoriesRes);
      
      that.state.gallery.update({
        categories: categoriesRes
      });

      if(that.state.isBasic === false)
        that.enterScreen();

      $(`#${ that.state.generatedId } .sidebar__consultation`).html(that.cloneConsultationButton());
      that.state.gallery.addLinkEventListeners();
    });
  }

  /**
  Category List listener
  adds an event listener to category titles in sidebar for collapsing and expanding the categories.
  */
  categoryListeners() {
    let $ref = $(`#${ this.state.generatedId }`);
    $ref.find('.category__name').off().on('click', function (e) {
      if (e) { e.preventDefault(); }
      $(this).closest('.category').toggleClass('open');

      if ($(this).closest('.category').hasClass('open')) {
        $(this).siblings('.category__list').slideToggle(175);
      } else {
        $(this).siblings('.category__list').slideToggle(100);
      }
    });
  }

  /**
  Filter List listener
  adds an event listener to filter titles in sidebar for collapsing and expanding the categories.
  */
  filtersListeners() {
    let that = this;

    let filtersContainer = $(`#${ this.state.generatedId },#gallery-mobile-filters`);
    let mobileFiltersContainer = $('#gallery-mobile-filters');
    let desktopFiltersContainer = $(`#${ this.state.generatedId }`);

    let filtersListClone = that.$ref.find('.sidebar__filters__list').children().clone(true);

    mobileFiltersContainer.find('.sidebar__filters__list').html(filtersListClone);

    filtersContainer.find('.filter__name').off().on('click', function(e){
      if (e) { e.preventDefault(); }

      $(this).closest('.filter').toggleClass('open');

      if ($(this).closest('.filter').hasClass('open')) {
        $(this).siblings('.filter__list--container').slideToggle(175);

      } else {
        $(this).siblings('.filter__list--container').slideToggle(100);
      }
    });

    filtersContainer.find('.filter__list__item').off().on('click', function(e) {
      if (e) { e.preventDefault(); }
      if (!$(this).hasClass('inactive') && !$(this).hasClass('perma-inactive')) {
        $(this).toggleClass('active');
        $(this).siblings().toggleClass('inactive');

        activateCounterPart($(this));

        that.activeFilterChecker();
      }
    });

    function activateCounterPart($el) {
      let withinDesktopFiltersList = $el.closest('.sidebar__filters__list').hasClass('gallery-desktop');
      let currentId = $el.attr('data-filterid');

      if (withinDesktopFiltersList) {
        mobileFiltersContainer.find(`.filter__list__item[data-filterid="${ currentId }"]`).toggleClass('active');
      } else {
        desktopFiltersContainer.find(`.filter__list__item[data-filterid="${ currentId }"]`).toggleClass('active');
      }
    }

    $(window).bind('clear-filters', function(e) {
      filtersContainer.find('.filter__list__item.active').removeClass('active');
      that.activeFilterChecker();
    });

    filtersContainer.find('.sidebar__clearall--link').off().on('click', function(e) {
      $(window).trigger('clear-filters');
    });

    // Happens on mobile/tablet only
    filtersContainer.find('.sidebar__filters__button').off().on('click', function(e) {
      if (e) { e.preventDefault(); }

      $('body').toggleClass('body-noscroll-tablet');
      mobileFiltersContainer.toggleClass('active');
    });

    that.activeFilterChecker();
  }

  /**
  This is responsible for check all on page selected items in the filters section. 

  - Appends the current selected item to the ".filter__list__active" within the targeted filter section 
    - Adds event listener to remove that item and deselect the selected item's counterpart (need to figure out how to connect the two... ).
  - Checks if "Clear All" button needs to be added and it will remove all active items then refire the default getCases without any content.
  - Then fires another function which collects all filter data items and sends it to the category getCases method.
  */
  activeFilterChecker() {
    let allFiltersRef = $(`#${ this.state.generatedId },#gallery-mobile-filters`);
    let $sidebarRefDesktop = this.$ref.find(`.sidebar__filters`);

    let that = this;
    
    // getting all the active and appending if they have not been appended.
    allFiltersRef.find('.filter__list__item.active').each(function(index, currentFilter) {
      let currentId = $(currentFilter).attr('data-filterid');;
      
      let findParentSelectedContainer = $(currentFilter).closest('.filter__list--container').siblings('.filter__list__active');

      if (!findParentSelectedContainer.find(`.sidebar__selected--single[data-filteridcounterpart="${ currentId }"]`).length) {
        
        let newItem = `
        <div class="sidebar__selected--single" data-filteridcounterpart="${ currentId }">
          <a>${ $(currentFilter).text() }</a>
        </div>`;

        // .sidebar__clearall
        $(currentFilter).closest('.sidebar__filters__list').siblings('.sidebar__clearall').append(newItem);
        findParentSelectedContainer.append(newItem);
      }
    });

    // checking to make sure the filter is still active
    allFiltersRef.find('.sidebar__selected--single').each(function(index, currentFilter) {
      let currentId = $(currentFilter).attr('data-filteridcounterpart');;

      if (!$(`.filter__list__item[data-filterid="${ currentId }"]`).hasClass('active')) {
        $(currentFilter).remove();
        $(`.filter__list__item[data-filterid="${ currentId }"]`).siblings().removeClass('inactive');
      }
    });


    allFiltersRef.find(`.sidebar__selected--single`).off().on('click', function(e) {
      if (e) { e.preventDefault(); }

      let currentId = $(this).attr('data-filteridcounterpart');

      allFiltersRef.find(`.filter__list__item[data-filterid="${ currentId }"]`).removeClass('active');
      that.activeFilterChecker();
    });

    // add clear all button if more than 1 selected
    if ($sidebarRefDesktop.find('.sidebar__selected--single').length > 0) {
      allFiltersRef.find('.sidebar__clearall').show();
      history.pushState(null, null, window.location.pathname + '?filters');
      this.updateState({
        addedFilters: true,
      });
    } else { // otherwise hide clear all
      allFiltersRef.find('.sidebar__clearall').hide();
      if (getUrlParameter('filters')) {
        history.pushState(null, null, window.location.pathname);
      }
    }

    that.generateFiltersRequestObject();
  }

  /**
  generateFiltersRequestObject

  This loops through all active filter items and collects the data within the data attribute on the item. 
  */
  generateFiltersRequestObject() {
    let $ref = this.$ref.find(`.sidebar__filters`);
    let that = this;

    let finalRequestObject = [];


    $ref.find('.filter__list__item.active').each(function(index, currentFilter) {
      let parentFilterObj = JSON.parse($(currentFilter).closest('.filter__list').attr('data-filterobj'));
      let filterValue = JSON.parse(decodeURI($(currentFilter).attr('data-request')));

      parentFilterObj.filter_values.push(filterValue);

      let foundInFinalObj = false;

      for (var i = 0; i < finalRequestObject.length; i++) {
        if (finalRequestObject[i].attribute_name === parentFilterObj.attribute_name) {
          foundInFinalObj = true;
          finalRequestObject[i].filter_values.push(filterValue);
        }
      }

      if (!foundInFinalObj) {
        finalRequestObject.push(parentFilterObj);
      }
    });

    if (finalRequestObject.length > 0) {
      // saving last instance
      that.state.gallery.update({
        lastSetOfCases: that.state.gallery.state.cases,
        currentCategoryCanonical: window.location.href.replace(window.location.origin, ''),
      });

      let getCasesRequest = {
        category_id: this.state.gallery.state.cases.category_id,
        filters: finalRequestObject,
        case_count: that.state.gallery.state.cases.cases_available,
      };
      
      that.state.category.resetCases();

      this.state.api.getCases(getCasesRequest, function(res) {
        if (res && res.case_count) {
          that.state.category.updateCases(res);
          
          that.state.gallery.update({
            cases: res,
          });

          that.state.category.generatePagination();
          that.state.gallery.addLinkEventListeners();
          
          $('.category__pagination').hide();
        }
      });
      
    } else {
      $('.category__pagination').show();

      if (that.state.gallery.state.lastSetOfCases && 
        that.state.gallery.state.lastSetOfCases.case_count !== that.state.gallery.state.cases.case_count
      ) {
        
        that.state.category.resetCases();

        that.state.gallery.update({
          cases: that.state.gallery.state.lastSetOfCases,
          currentCategoryCanonical: window.location.href.replace(window.location.origin, ''),
        });
        that.state.category.updateCases(that.state.gallery.state.cases);
      }
    }
  }

  /**
  renderFilers
  @param allFilers {array} - loops through array generating html markup for active filters and append them into the sidebar filters section. 
  */
  renderFilters(allFilters) {
    const that = this;
    // confirm we are getting an array
    if (Array.isArray(allFilters)) {
      let finalList = '';
      let multipleFiltersList = {};

      allFilters.map((filter, index) => {
        if (filter.active) {
          
          if (isMultiple(filter.attribute_name)) {
            // 1. remove before/after from attribute_name
            // 2. determine if value exists in temp object,
                // 2. a. If it does, add this to appropriate section then run generating function
                // 2. b. If not create new key for filter values.

            let currentFilter = determineBeforeOrAfter(filter);
            let targetFilterName = currentFilter.attribute_name.replace(/-/g, '');

            if (multipleFiltersList[targetFilterName] !== undefined) { // if found...
              multipleFiltersList[targetFilterName][currentFilter.type] = currentFilter.filter_values;
              multipleFiltersList[targetFilterName][currentFilter.type + 'orig'] = filter;

              finalList += that.generateFilterMultipleContainer(multipleFiltersList[targetFilterName]);
            } else { // otherwise create a new object
              multipleFiltersList[targetFilterName] = {};
              multipleFiltersList[targetFilterName].name = currentFilter.attribute_name;
              multipleFiltersList[targetFilterName][currentFilter.type] = currentFilter.filter_values;
              multipleFiltersList[targetFilterName][currentFilter.type + 'orig'] = filter;
            }
          } else {
            finalList += that.generateFilterSingleContainer(filter, that.generateFilterListMarkup(filter.filter_values));
          }
        }
      });

      let filtersMount = $(`#${ that.state.generatedId } .sidebar__filters__list`);

      filtersMount.html(finalList);
      this.filtersListeners();
    }

    function isMultiple(filterName) {
      if (filterName.toLowerCase().indexOf('before') !== -1) {
        return true;
      } else if (filterName.toLowerCase().indexOf('after') !== -1) {
        return true;
      } else {
        return false;
      }
    } 

    function determineBeforeOrAfter(filter) {
      let beforeOrAfter = undefined;
      let filterName = filter.attribute_name.toLowerCase();
      let after = 'after';
      let before = 'before';

      let obj = {
        attribute_name: '',
        filter_values: filter.filter_values,
        type: undefined,
      };

      if (filterName.indexOf('before') !== -1) {
        let currentBeforeIndex = filterName.indexOf(before);
        let nameWithoutBefore = filterName.slice(0, -(before.length + 1));

        obj.type = before;
        obj.attribute_name = nameWithoutBefore.replace(/ /g, '-');

      } else if (filterName.toLowerCase().indexOf(after) !== -1) {
        let currentAfterIndex = filterName.indexOf(after);
        let nameWithoutAfter = filterName.slice(0, -(after.length + 1));

        obj.type = after;
        obj.attribute_name = nameWithoutAfter.replace(/ /g, '-');
      }

      return obj;
    }
  }

  generateFilterListMarkup(filterList) {
    let filterHtml = '';

    filterList.sort((a, b) => a.sort - b.sort).map((filterValue) => {
      let activeClass = filterValue.selected ? 'active' : '';
      let isInactive = (filterValue.case_count >= 1) ? '' : 'perma-inactive inactive';

      let futureRequestObj = Object.assign({}, filterValue, {
        display_name: filterValue.display_name,
        selected: true,
      });

      let stringifiedRequestObj = JSON.stringify(futureRequestObj);

      filterHtml += `
        <li data-request="${ encodeURI(stringifiedRequestObj) }" data-filterid="filter-${ generateUID() }" class="filter__list__item ${ activeClass }${ isInactive }">${ filterValue.display_name }</li>
      `;
    });

    return filterHtml;
  }

  generateFilterSingleContainer(filter, generatedFilterList) {
    let filterWithoutValues = Object.assign({}, filter, {
      filter_values: [],
    });

    return `
      <li class="filter">
        <h3 class="filter__name">${ filter.attribute_name }</h3>
        <div class="filter__list__active"></div>
        <div class="filter__list--container" style="display: none;">
          <ul class="filter__list" data-filterobj='${ JSON.stringify(filterWithoutValues) }'>${ generatedFilterList }</ul>
        </div>
      </li>
    `;
  }

  generateFilterMultipleContainer(multipleFilterObj) {
    let beforeFilterWithoutValues = Object.assign({}, multipleFilterObj.beforeorig, {
      filter_values: [],
    });
    let afterFilterWithoutValues = Object.assign({}, multipleFilterObj.afterorig, {
      filter_values: [],
    });

    return `
      <li class="filter">
        <h3 class="filter__name filter__name--multiple">${ multipleFilterObj.name.replace(/-/g, ' ') }</h3>
        <div class="filter__list__active"></div>
        <div class="filter__list--container filter__list__multiple" style="display: none;">
          <div class="filter__list__multiple__before">
            <p><strong>Before</strong></p>
            <ul class="filter__list" data-filterobj='${ JSON.stringify(beforeFilterWithoutValues) }'>
              ${ this.generateFilterListMarkup(multipleFilterObj.before) }
            </ul>
          </div>
          <div class="filter__list__multiple__after">
            <p><strong>After</strong></p>
            <ul class="filter__list" data-filterobj='${ JSON.stringify(afterFilterWithoutValues) }'>
              ${ this.generateFilterListMarkup(multipleFilterObj.after) }
            </ul>
          </div>
        </div>
      </li>
    `;
  }

  /**
  renderProcedures
  @param proceduresArray {array} - loops through array and orders them based on the returned sequence_value

  - this also generates the procedures category menu html
  */
  renderProcedures(proceduresArray) {
    if (proceduresArray && proceduresArray.length) {
      let allProcedures = proceduresArray.sort((a, b) => a.sequence_value - b.sequence_value);
      let children = '';

      for(let i = 0; i < allProcedures.length; i++) {
        let currentCategoryParent = proceduresArray[i];
        let currentCategoryChildren = currentCategoryParent.subcategories.sort((a, b) => a.sequence_value - b.sequence_value);

        let isFirstCategory = (i === 0);

        let categoryTemplate = `<li class="category ${ isFirstCategory ? 'open' : '' }">
          <h3 class="category__name">${ currentCategoryParent.category_name }</h3>
          <ul class="category__list" ${ isFirstCategory ? '' : 'style="display: none;"' }>
            ${ generateCategoryMenu(currentCategoryChildren) }
          </ul>
        </li>`;

        children += categoryTemplate;
      }

      function generateCategoryMenu(subCategoryArr) {
        let allSubLinks = '';
        for (let i = 0; i < subCategoryArr.length; i++) {
          let currentCategory = subCategoryArr[i];
          let isAdult = (currentCategory.adult) ? 'adult' : '';

          let linkTemplate = `
            <li class="category__list__item">
              <a href="${ currentCategory.category_canonical_url }" data-id="${ currentCategory.category_id }" class="category__list__item__link ${ isAdult }">
                ${ currentCategory.category_name }
              </a>
            </li>`;

            allSubLinks += linkTemplate;
        }

        return allSubLinks;
      }
      let finalList = children;

      let $ref = $(`#${ this.state.generatedId }`);

      $ref.find('.sidebar__categories__list').html(finalList);

      this.categoryListeners();
    }
  }

  /**
    When within the categories page a button is displayed to go back to the landing page. This is called within the spine of the application on load and sets the back link to the landing page (which can be / or /gallery or whatever the developer sets it as).
  */
  setGalleryBackLink(link) {
    let $ref = $(`#${ this.state.generatedId }`);

    $ref.find('.sidebar__categories__button, .sidebar__categories__selected-procedure').attr('href', link);
  }

  /**
  This method is called if on the landing page, this sidebar is responsible for updating itself. 
  If on landing page, this will make sure to only display the categories sidebar and hide the filters section as well as the back button
  */
  isLandingPage() {
    let $ref = $(`#${ this.state.generatedId }`);
    $ref.show();

    // Hiding gallery back button & Filters
    $ref.find('.sidebar__categories__button').slideUp();
    $ref.find('.sidebar__filters').slideUp();


    // showing entire category list
    $ref.find('.sidebar__categories__list').slideDown();
  }

  /**
  If on the category page it will update the back button text using `updateBackButtonText`, otherwise it will fetch to the API and get the categories then update the text. 

  The only time it will reach out to the API to get the categories will be if the page is refreshed, or linked directly to it if on a categories page.
  */
  isCategoryPage(newState, gallery) {
    if (getUrlParameter('filters')) {
      this.activeFilterChecker();
    }

    if (this.state.gallery.state.categories.length) {
      this.updateBackButtonText(this.state.gallery.state.categories);
    } else {
      this.state.api.getCategories((res) => {
        this.updateBackButtonText(res);
      });
    }

    let $ref = $(`#${ this.state.generatedId }`);
    $ref.show();

    // hide entire category list
    $ref.find('.sidebar__categories__list').slideUp();

    // Show gallery back button & Filters
    
    $ref.find('.sidebar__categories__button').slideDown();
    $ref.find('.sidebar__filters').slideDown();
  }

  /**
    This will get the current route, with no parameters on it, then loop through all categories and put all subcategories in a single flattened array. 
    It will then find the current category that matches the category_canonical_url to the route without a param ant update the button text.
  */
  updateBackButtonText(allCategories) {
    let $ref = $(`#${ this.state.generatedId }`);
    let nextRouteNoParam = this.state.gallery.state.currentCategoryCanonical.split('?')[0];

    let allSubcategories = [];

    for (let i = 0; i < allCategories.length; i++) {
      allSubcategories.push(allCategories[i].subcategories);
    }
    
    allSubcategories = flattenMultiArray(allSubcategories);

    let backButtonText = $.grep(allSubcategories, (subcategory) => subcategory.category_canonical_url === decodeURI(nextRouteNoParam));

    if (backButtonText.length) {
      backButtonText = backButtonText[0].category_name;
    }    

    $ref.find('.sidebar__categories__button .gallery-desktop, .sidebar__categories__selected-procedure').text(backButtonText);
  }

  /**
  If on account section, this needs to hide.
  */
  isAccountSection() {
    this.$ref.hide();
  } 

  /**
  if on cases page we will just hide the sidebar
  */
  isCasePage() {
    let $ref = $(`#${ this.state.generatedId }`);
    $ref.hide();
  }

  /**
  Initial render function contains the basic layout for the sidebar. If categories data exists, it will be parsed and `renderProcedures` method will fire.
  */
  render(categoriesData) {
    return `
      <div class="sidebar__categories">
        <a href="" class="sidebar__categories__button" style="display: none;"><span class="gallery-mobile">Procedure</span><span class="gallery-desktop">&nbsp;</span></a>
        
        <div class="sidebar__selected categories_only">
          <a href="" class="gallery-mobile sidebar__categories__selected-procedure"></a>
        </div>

        <ul class="sidebar__categories__list" style="display: none;">${ this.renderProcedures(categoriesData) || '' }</ul>
      </div>
      <div class="sidebar__filters" style="display: none;">
        <h2 class="sidebar__title gallery-desktop">Filter Options</h2>
        
        <a href="" class="sidebar__filters__button"><span class="gallery-mobile">Filters</span><span class="gallery-desktop">&nbsp;</span></a>

        <div class="sidebar__clearall" style="display: none;">
          <a class="sidebar__clearall--link">Clear All</a>
        </div>
        <ul class="sidebar__filters__list gallery-desktop"></ul>
      </div>
      <div class="sidebar__consultation"></div>
    `;
  }
}



export default GallerySidebar;


// WEBPACK FOOTER //
// ./src/scripts/site/gallery-views/GallerySidebar.js